import React from 'react';

const HealthCheckPatternMob = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 428 828" fill="none">
      <g clip-path="url(#clip0_418_4649)">
        <rect width="428" height="828" fill="white" />
        <g opacity="0.41">
          <rect x="276.551" y="707.156" width="7.58569" height="20.4091" fill="#DDCAEB" />
          <rect x="290.457" y="713.477" width="7.58569" height="20.4091" transform="rotate(90 290.457 713.477)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="131.32" y="734.846" width="7.58569" height="20.4091" fill="#DDCAEB" />
          <rect x="145.227" y="741.167" width="7.58569" height="20.4091" transform="rotate(90 145.227 741.167)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="213.701" y="734.959" width="11.2136" height="30.17" fill="#DDCAEB" />
          <rect x="234.26" y="744.304" width="11.2136" height="30.17" transform="rotate(90 234.26 744.304)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="68.4707" y="762.649" width="11.2136" height="30.17" fill="#DDCAEB" />
          <rect x="89.0293" y="771.994" width="11.2136" height="30.17" transform="rotate(90 89.0293 771.994)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="261.25" y="721.058" width="5.60682" height="15.085" fill="#DDCAEB" />
          <rect x="271.529" y="725.73" width="5.60682" height="15.085" transform="rotate(90 271.529 725.73)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="116.02" y="748.748" width="5.60682" height="15.085" fill="#DDCAEB" />
          <rect x="126.299" y="753.42" width="5.60682" height="15.085" transform="rotate(90 126.299 753.42)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="235.051" y="703.31" width="7.47575" height="20.1133" fill="#DDCAEB" />
          <rect x="248.756" y="709.54" width="7.47575" height="20.1133" transform="rotate(90 248.756 709.54)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="89.8203" y="731" width="7.47575" height="20.1133" fill="#DDCAEB" />
          <rect x="103.525" y="737.229" width="7.47575" height="20.1133" transform="rotate(90 103.525 737.229)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="171.035" y="707.156" width="5.60682" height="15.085" fill="#DDCAEB" />
          <rect x="181.314" y="711.828" width="5.60682" height="15.085" transform="rotate(90 181.314 711.828)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="25.8047" y="734.846" width="5.60682" height="15.085" fill="#DDCAEB" />
          <rect x="36.084" y="739.518" width="5.60682" height="15.085" transform="rotate(90 36.084 739.518)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="210.377" y="690" width="5.60682" height="15.085" fill="#DDCAEB" />
          <rect x="220.658" y="694.672" width="5.60682" height="15.085" transform="rotate(90 220.658 694.672)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="155.951" y="690" width="5.60682" height="15.085" fill="#DDCAEB" />
          <rect x="166.232" y="694.672" width="5.60682" height="15.085" transform="rotate(90 166.232 694.672)" fill="#DDCAEB" />
        </g>
        <path opacity="0.18" d="M260.496 792.47C212.241 776.688 66.7256 794.898 0 805.976V828.131H428V690.797C379.902 686.851 297.989 695.592 355.114 762.12C412.24 828.647 315.838 810.073 260.496 792.47Z" fill="#7F4A9B" />
      </g>
      <defs>
        <clipPath id="clip0_418_4649">
          <rect width="428" height="828" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HealthCheckPatternMob;